import React, { useEffect, useState } from "react";
import { Button, Navbar, Modal } from "react-bootstrap";
import { ImgLogo } from "../style/images";
import "./Navbar.scss";
import {
  UserIsLoggedIn,
  Logout,
  PageWithoutAuthorization,
} from "../Authentication/UserStatus";
import { getCookie } from "../Uitilities/cookie";
import axios from "Uitilities/axios";
import { current } from "@reduxjs/toolkit";

const NavBar = () => {
  const [userName, setUserName] = useState(getCookie("cName"));
  const [editName, setEditName] = useState(false);
  const [show, setShow] = useState(false);
  function IsUnathorizedPage() {
    let pathOnly = window.location.pathname.replace(
      `${process.env.PUBLIC_URL}/`,
      ""
    );
    return PageWithoutAuthorization.includes(pathOnly);
  }

  const LogoutButton = () => {
    Logout();
    window.location.href = "./Login";
  };

  useEffect(() => {
    function checkUserStatus() {
      if (!UserIsLoggedIn() && !IsUnathorizedPage()) {
        window.location.href = "./Login";
      }
    }

    checkUserStatus();
  }, []);

  const handleClose = () => setShow(false);
  function uploadUserName() {
    axios
      .put(`Identity/User`, {
        CName: userName,
      })
      .then((res) => {
        console.log(res);
        if (res.data) {
          alert("更新成功");
          setEditName(false);
        }
      });
  }
  const [origin, setorigin] = useState("");
  const [newpassword, setnewpassword] = useState("");
  const [checkpassword, setcheckpassword] = useState("");
  function ChangePassword() {
    if (newpassword === checkpassword) {
      let payload = {
        currentPassword: origin,
        newPassword: newpassword,
      };
      axios
        .post("Identity/changePassword", payload)
        .then((res) => {
          if (res.status == 200) {
            alert("變更成功");
            ClearPassword();
            setShow(false);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 400) {
            alert("原始密碼不一致");
          }
          if (err.response.status === 404) {
            alert("沒使用者");
          }
        });
    } else {
      alert("新密碼輸入不一致");
    }
  }
  function ClearPassword() {
    setorigin("");
    setnewpassword("");
    setcheckpassword("");
  }

  return (
    <>
      <div className="l-grid-menu-layout__navi">
        <Navbar className="main-navbar">
          <div className="navbar-container" id="navbar-container">
            <div className=" d-flex">
              <a href="#navbar-container">
                <img src={ImgLogo} alt="logo" height="35" />
              </a>
              <a href="#navbar-container" className="navbar-title">
                桃園市橋梁及地下道管理系統
              </a>
            </div>
            <div className=" d-flex">
              <div className="l-navi__item">
                <i className="icon-user-outline"></i>
                {editName ? (
                  <>
                    <input
                      type="text"
                      value={userName}
                      onChange={(e) => {
                        setUserName(e.target.value);
                      }}
                    />
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        uploadUserName();
                      }}
                    >
                      儲存
                    </a>
                  </>
                ) : (
                  <>
                    <span className="js-lab_userName">{userName}</span>
                    <i
                      className="icon-edit"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setEditName(true);
                      }}
                    ></i>
                  </>
                )}
              </div>
              <div className="l-navi__item ">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShow(true);
                  }}
                >
                  <i className="icon-setting"></i>設定
                </a>
              </div>
              <div className="l-navi__item ">
                <Button className="logout-btn" onClick={LogoutButton}>
                  <p>登出</p>
                </Button>
              </div>
            </div>
          </div>
        </Navbar>
      </div>
      <Modal
        size="m"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>變更密碼</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex row align-items-end">
            <div className="form-row d-flex">
              <div className="col-form-label p-col-3 p-col-xs-3 p-text-left p-text-xs-right">
                原始密碼：
              </div>
              <div className="p-col-9 p-col-xs-9 mb-1">
                <input
                  type="password"
                  className="form-control"
                  value={origin}
                  onChange={(e) => {
                    setorigin(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="form-row d-flex">
              <div className="col-form-label p-col-3 p-col-xs-3 p-text-left p-text-xs-right">
                請輸入新密碼：
              </div>
              <div className="p-col-9 p-col-xs-9 mb-1">
                <input
                  type="password"
                  className="form-control"
                  value={newpassword}
                  onChange={(e) => {
                    setnewpassword(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="form-row d-flex">
              <div className="col-form-label p-col-3 p-col-xs-3 p-text-left p-text-xs-right">
                再次輸入新密碼：
              </div>
              <div className="p-col-9 p-col-xs-9 mb-1">
                <input
                  type="password"
                  className="form-control"
                  value={checkpassword}
                  onChange={(e) => {
                    setcheckpassword(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-xl-3 d-flex align-items-center  my-2 w-100 justify-content-end">
            <Button
              variant="primary"
              className="btn_view btn btn-danger mx-2"
              onClick={() => {
                ChangePassword();
              }}
            >
              變更密碼
            </Button>
            <Button
              variant="primary"
              className="btn_view btn btn-primary mx-2"
              onClick={() => {
                ClearPassword();
                setShow();
              }}
            >
              關閉
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NavBar;
